"use client";

import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "@/store";
import {
  createStripeCustomer,
  createSepaSetupSession,
  finalizeSepaSetupSession,
} from "@/store/modules/stripe/thunks";

const useStripe = () => {
  const dispatch: AppDispatch = useDispatch();

  const createCustomer = useCallback(
    async (payload: any) => {
      const result = await dispatch(createStripeCustomer(payload));
      return result;
    },
    [dispatch],
  );

  const createSepaSession = useCallback(
    async (payload: any) => {
      const result = await dispatch(createSepaSetupSession(payload));
      return result;
    },
    [dispatch],
  );

  const finalizeSepa = useCallback(
    async (payload: any) => {
      const result = await dispatch(finalizeSepaSetupSession(payload));
      return result;
    },
    [dispatch],
  );

  return {
    createCustomer,
    createSepaSession,
    finalizeSepa,
  };
};

export default useStripe;
